import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "semantic-ui-react";
import DropDown from "../../../../commonComponents/formComponents/dropDown";
import { selectCountryList008, selectCountryList199 } from "../../../selectors";
import PopUpIcon from "../../../../commonComponents/formComponents/PopUpIcon";
import { TranslateContext } from "../../TranslateContext";
import SecurityInfo from "./securityInfo";
import { Country } from "../../../../commonComponents/dropdown/country";
import RoutingModal from "../../../../commonComponents/routingModal";
import { useCurrentShipmentType, useForm } from "../../../../hooks";
import { useDocument } from "../../../hooks/useDocument";
import * as ActionTypes from '../../../actions/actionTypes'
import { CustomLoader } from "../../../../commonComponents/formComponents/loader";

const ItineraryForm = ({ isImportShipment, isDMS, saveData, onUpdate, displayInfo: { tranNatureInfo, paymentInfo }, dataSource: { paymentMethod, valuationMethod, transactionNature, itinerary }, disableForm }) => {

  const dispatch = useDispatch()
  const expWayOfPaymentList = useSelector((state) => state.DropDownValues.expWaysOfPayment);
  const countryList199 = useSelector(selectCountryList199)?.filter(itm=> itm.type==='EU' || itm.type==='CO')
  const valuationMethodList = useSelector((state) => state.DropDownValues.valuationMethods);
  const transactionNatureList = useSelector((state) => state.DropDownValues.transactionNature)
  const translate = React.useContext(TranslateContext).translate
  const itineraryList = useSelector(state => state.Shipment.itinerary).sort((prev, next) => prev.orderNumber - next.orderNumber)
  const { isDisabled } = useCurrentShipmentType()

  const { deleteItem, updateItem, saveItem } = useDocument({ actionType: "HEADER", tableName: "itinerary", containerKey: "header" })
  const { isLoading, saveForm}=useForm('header')
  const addItinerary = async (params) => {
    const request =  {
      countryCode: params?.countryCode || "ZZ",
      orderNumber: itineraryList?.length ? parseInt(itineraryList?.slice(-1)[0].orderNumber) + 1 : 1
    }
    const response = await saveForm({ [`itinerary`]: [{ id: "", ...request }] })
    if (response) {
      dispatch({
        type: ActionTypes[`ADD_ITEM_HEADER`],
        payload: { id: response.responseMessage, ...request },
        meta: { tableName: 'itinerary' }
      })
    }
  }

  const RenderItinerary = ({ disabled, errors }) => {
    return (
      <Country
        id="itinerary"
        label={translate("ITINERARY", { ns: ["default", "header"] })}
        boxNumber="21"
        disabled={disabled || itineraryList?.length > 0}
        value={(!isDMS && !isImportShipment) ? itineraryList?.slice(-1)[0]?.countryCode || '' : itinerary}
        text={(!isDMS && !isImportShipment) ? (
          itineraryList?.slice(-1)[0]?.countryCode !== 'ZZ' 
          && itineraryList?.slice(-1)[0]?.countryCode) || '' : itinerary}
        dataSource={countryList199}
        errors={errors}
        onChange={(value) => {
          if (!isDMS && !isImportShipment) {
            addItinerary({ countryCode: value })
          } else {
            saveData({ itinerary: value })
            onUpdate({ "itinerary": value?.trim() })
          }
        }}

      />
    )
  }
  const renderTransNature = () => {
    return (
      <DropDown
        id="transactionNature"
        label={
          <React.Fragment>
            {tranNatureInfo && <PopUpIcon icon="info circle" popupText={<ul><li>{translate("TRANSACTION_METHOD_POPUPTEXT", { ns: ["default", "header"], tranNatureProc: tranNatureInfo })}</li></ul>} />}
            {translate("TRANSACTION_NATURE", { ns: ["default", "header"] })}
          </React.Fragment>
        }
        data={transactionNatureList}
        className="field-bg dropdown100"
        boxNumber="21"
        clearable
        value={transactionNature}
        onChange={(value) => {
          saveData({ transactionNature: value })
          onUpdate({ "transactionNature": value })
        }}
        {...disableForm.disableTranNature}
      />
    )
  }
  return (
    <React.Fragment>
      {
        !isImportShipment &&
        <>
          {
            isDMS && <SecurityInfo
              renderItinerary={RenderItinerary}
              translate={translate}
              saveData={saveData}></SecurityInfo>
          }
          <Grid.Row>
            {!isDMS && (<>
              <Grid.Column width="3" className="divFormFeild" style={{ borderRight: '0' }}>
                {RenderItinerary({})}
              </Grid.Column>
              <Grid.Column width="1" className="divFormFeild">
                {isLoading && <CustomLoader />}
                <RoutingModal
                  isFormDisabled={isDisabled}
                  headerName='ITINERARIES'
                  triggerContent={<span style={{
                    textAlign: 'center',
                    marginTop: '12px',
                    fontWeight: '800',
                    color: 'blue',
                    cursor: 'pointer',
                    display: itineraryList?.length === 0 ? 'none' : 'block'
                  }}>
                    +{itineraryList?.length - 1}
                  </span>}
                  valueKey='countryCode'
                  limit={6}
                  AddItem={addItinerary}
                  saveData={saveItem}
                  updateData={updateItem}
                  deleteData={deleteItem}
                  dataList={itineraryList}
                  dataSource={countryList199}
                  fieldType={'dropdown'}
                  countryCode='NL'
                />

              </Grid.Column>
            </>
            )}

            <Grid.Column width="4" className="divFormFeild">
              <DropDown
                id="paymentMethod"
                label={
                  <React.Fragment>
                    {
                      paymentInfo && <PopUpIcon icon="info circle"
                        popupText={<ul><li>{translate("PAYMENT_METHOD_POPUPTEXT", { ns: ["default", "header"], paymentProc: paymentInfo })}</li></ul>} />
                    }
                    {translate("PAYMENT_METHOD", { ns: ["default", "header"] })}
                  </React.Fragment>
                }

                data={expWayOfPaymentList}
                {...disableForm.disabledPaymentInfo}
                className="field-bg dropdown100"
                boxNumber="15"
                clearable
                value={paymentMethod}
                onChange={(value) => {
                  saveData({ paymentMethod: value })
                  onUpdate({ "paymentMethod": value })
                }
                }
              />

            </Grid.Column>
            <Grid.Column width={!isDMS ? "8" : "12"} className="divFormFeild">
              {renderTransNature()}

            </Grid.Column>

          </Grid.Row>
        </>
      }
      {isImportShipment &&
        <Grid.Row>
          <Grid.Column width="8" className="divFormFeild">
            {renderTransNature()}

          </Grid.Column>
          <Grid.Column width="8" className="divFormFeild">
            <DropDown
              id="valuationMethod"
              label={translate("VALUATION_METHOD", { ns: ["default", "header"] })}
              data={valuationMethodList}
              className="field-bg dropdown100"
              boxNumber="4/17"
              clearable
              value={valuationMethod}
              onChange={(value) => {
                saveData({ valuationMethod: value })
                onUpdate({ "valuationMethod": value })
              }}

            />

          </Grid.Column>
        </Grid.Row>
      }
    </React.Fragment>
  );
}

ItineraryForm.defaultProps = {
  dataSource: {},
  disableForm: { disableTranNature: {}, disabledPaymentInfo: {} },
  displayInfo: { tranNature: "", paymentInfo: "" }
}
export default React.memo(ItineraryForm)
